import netsNumPad from './nets-num-pad';
import moduleConfig from './module-config';

export default angular
  .module('app.num-pad', [])
  .config(['$stateProvider', moduleConfig])
  .component('netsNumPad', netsNumPad);
